export default "__VITE_ASSET__DSxt0qKP__"